import { isNil, isNumber } from 'lodash'

class DialogState {
  static LocalStorageKey = 'DIALOG_INTERACTIVE_ACTIONS_STATE' // 弹窗交互行为操作状态
  constructor() {
    // 缓存 1、定位
    this.localState = this.getLocalState()
    // 缓存弹窗实例
    this.instanceStore = {}
    window.dialogState = this
    this.clearExpire()
  }
  clearExpire() {
    for (const sceneType in this.localState) {
      const log = this.localState[sceneType]
      // 删除超过7天的历史数据, 历史脏数据也删除!log.registerTime
      if (!log.registerTime || (log.registerTime && Date.now() - log.registerTime > 3600 * 24 * 7)) {
        delete this.localState[sceneType]
      }
    }
    this.setLocalState()
  }

  /**
   * 注册弹窗组件状态
   * 打开时弹窗时show()
   * @param sceneType 场景类
   * @param instance 弹窗实例
   */
  register = (sceneType, instance) => {
    if (!instance || !sceneType) return
    // 互斥弹窗，如果sceneType相同，则sceneType下其他所有弹窗都需要关闭，防止定位错乱和其他异常
    try {
      if (this.instanceStore[sceneType]) {
        // 销毁其他所有弹窗，不受管控的弹窗都应该销毁, 覆盖前一定先销毁之前的弹窗
        // this.destroyDialogByIns(this.instanceStore[sceneType])
      } else {
        this.instanceStore[sceneType] = instance
      }
      this.update(sceneType, { visible: true, registerTime: Date.now() }) // 打开状态
    } catch (e) {
      console.error(e)
    }
    return this
  }

  /**
   * 销毁弹窗实例
   * @param ins
   */
  destroyDialogByIns(ins) {
    if (!ins) return
    try {
      ins?.destroy?.()
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * 根据弹窗场景type销毁实例
   * @param sceneType
   */
  destroyDialogBySceneType(sceneType) {
    if (!sceneType) return
    // 销毁其他所有弹窗，不受管控的弹窗都应该销毁
    this.destroyDialogByIns(this.instanceStore[sceneType])
    this.update(sceneType, { visible: false }) // 更新打开状态
  }

  /**
   * 清除弹窗历史记录
   * @param sceneType
   */
  clearHistoryAndDestroy(sceneType) {
    this.destroyDialogBySceneType(sceneType)
    delete this.localState[sceneType]
    this.setLocalState()
  }

  /**
   * 是否存在历史打开的弹窗记录
   */
  hasOpenedHistory(sceneType) {
    const log = this.localState[sceneType]
    console.log(2222, sceneType, log)

    return log && log.visible
  }

  /**
   * 关闭所有弹窗
   * 1、适用于切换会话时
   * 2、离开页面时
   */
  destroyAll(handleClose = false) {
    try {
      for (const sceneType in this.instanceStore) {
        const instance = this.instanceStore[sceneType]
        if (!instance) return
        instance?.destroy?.()
      }
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * 更新状态
   * @param sceneType 场景类型
   * @param params {object}
   */
  update = (sceneType, params) => {
    if (!sceneType) return
    if (!this.localState[sceneType]) this.localState[sceneType] = {}
    Object.assign(this.localState[sceneType], params)
    this.setLocalState()
    return this.localState[sceneType]
  }

  /**
   * 手动关闭弹窗
   */
  handleClose(sceneType) {
    this.update(sceneType, { visible: false })
  }

  /**
   * 赋值初始定位
   * @param sceneType 相同场景内共享位置
   * @param instance
   * @param defaultPosition
   */
  position = (sceneType, instance, defaultPosition) => {
    if (!instance) return
    try {
      if (!this.localState[sceneType]) {
        if (!defaultPosition) {
          // 如果未设置默认位置，使用默认margin居中定位
          // this.setPosition(instance)
          return
        }
        // 如果设定了默认位置，赋值初始位置
        if (defaultPosition) this.setPosition(instance, defaultPosition?.left, defaultPosition?.top)
        return
      }
      const { leftPx, topPx } = this.localState[sceneType]
      // 如果读取的是空值, 即使到边界也不可能为0px
      if (this.isEmptyPx(leftPx) || this.isEmptyPx(topPx)) {
        this.setPosition(instance, defaultPosition?.left, defaultPosition?.top)
        this.update(sceneType, {
          leftPx: this.getPx(defaultPosition?.left),
          topPx: this.getPx(defaultPosition?.top)
        })
        return
      }
      this.setPosition(instance, leftPx, topPx)
    } catch (e) {
      console.error(e)
    }
  }
  isEmptyPx(px) {
    return !px || px === '0px' || px === '0'
  }
  getPx(px) {
    if (isNumber(px)) px += 'px'
    return px
  }
  setPosition(instance, leftPx, topPx) {
    try {
      const dialogVmDom = instance?.$el?.firstChild
      if (!dialogVmDom) return
      if (isNil(leftPx) || isNil(topPx)) {
        // 如果为空不处理定位
      } else {
        dialogVmDom.style.left = this.getPx(leftPx)
        dialogVmDom.style.top = this.getPx(topPx)
      }
    } catch (e) {
      console.error(e)
    } finally {
      instance.resize() // 自适应调整，防止超出边界
    }
  }
  /**
   * 按照前缀销毁弹窗
   * @param sceneTypePrefix
   */
  destroyAllByPrefix(sceneTypePrefix) {
    try {
      for (const sceneTypeKey in this.instanceStore) {
        if (sceneTypePrefix && sceneTypeKey.startsWith(sceneTypePrefix)) {
          const instance = this.instanceStore[sceneTypeKey]
          instance?.destroy?.()
          delete this.instanceStore[sceneTypeKey]
          break
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  getLocalState() {
    try {
      const logJson = window.localStorage.getItem(DialogState.LocalStorageKey)
      return JSON.parse(logJson) || {}
    } catch (e) {
      return {}
    }
  }

  setLocalState(localState = this.localState) {
    try {
      window.localStorage.setItem(DialogState.LocalStorageKey, JSON.stringify(localState, null, 2))
    } catch (e) {
      console.error(e, localState)
    }
  }
}

export default new DialogState()
